import React from 'react';
import Match from './Match';
import {MatchInterface} from './matchInterface';


interface MatchSectionBottomProps {
    line1: (MatchInterface | undefined)[];
    line2: (MatchInterface | undefined)[];
}

const MatchSection = ({line1 = [], line2 = []}: MatchSectionBottomProps): React.ReactNode => <div className="match-section-bottom">
    <div className="line">
        <Match match={line1[0]}/>
        <Match match={line1[1]}/>
    </div>
    <div className="line">
        <Match match={line2[0]}/>
        <Match match={line2[1]}/>
    </div>
</div>;

export default MatchSection;
